import { Data } from "../../../../../features/data-types"
import { Table, Section, Column, FieldType, FieldValue } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { define } from "../../../../../utils/typeUtils"
import { useCashFundLoaders } from "../../../loaders/cashFundLoaders"

type Props = {
    rows: Data[]
    disableCreate?: boolean
    readOnly?: boolean
    onCreate?: () => void
    onRemoveRow?: (cashFundId: string) => void
}

export const CashFundItemsTable = (props: Props) => {
    const { rows, disableCreate, readOnly, onCreate, onRemoveRow } = props

    const cashFundLoaders = useCashFundLoaders()
    
    const columns: Column[] = [
        {
            name: 'cashFundId',
            type: FieldType.TABLE,
            table: TableName.CASH_FUNDS,
            label: '',
            render: (value?: FieldValue) => {
                const cashFund = cashFundLoaders().findCashFund(define(value) as string)
                return define(cashFund).name
            }
        }
    ]

    return (
        <Section
            id='cashFundItems'
            title={readOnly ? 'Cajas Asociadas' : ''}
            space={readOnly ? 8 : 12}
        >
            <Table
                columns={columns}
                rows={rows}
                rowId="cashFundId"
                disableCreate={disableCreate}
                readOnly={readOnly}
                createIcon="plus"
                small
                onCreate={onCreate}
                onRemove={onRemoveRow}
            />
        </Section>
    )
}
